<template>
  <!-- Modal -->
  <div class="modal fade" id="StockingModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <vue-element-loading :active="isLoading" spinner="bar-fade-scale" color="#333"/>
        <div class="modal-header">
          <h5 class="modal-title font-weight-bold">{{translations('purchase.arrival_processing')}}</h5>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <div v-if="displayWarning" class="alert alert-danger">{{translations('purchase.notification_message_date')}}</div>
          <div class="table-scroll">
          <table class="table table-striped table-align-middle">
            <thead>
              <tr>
                <th>{{translations('purchase.arrival_date')}}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <input v-model="shippingAt" type="date" class="form-control">
                </td>
              </tr>
            </tbody>
          </table>
          </div>
          <div class="table-scroll">
          <table class="table table-striped table-align-middle">
            <thead>
              <tr>
                <th>{{translations('purchase.jan_code')}}</th>
                <th>{{translations('purchase.model')}}</th>
                <th>{{translations('purchase.count')}}</th>
                <th>{{translations('purchase.received_quantity')}}</th>
                <th>{{translations('purchase.quantity_stock')}}</th>
              </tr>
            </thead>
            <tbody class="nowrap">
              <template v-for="(product, i) in warehouseProducts">
              <tr :key="i">
                <td>{{ product.jan_code }}</td>
                <td>{{ product.model }}</td>
                <td class="right">{{ product.quantity }}</td>
                <td class="right">{{ product.arrived_quantity }}</td>
                <td>
                  <input v-model="product.shippingAmount" class="form-control form-control-sm" type="text" placeholder="0" min-value="0" :disabled="product.remain_quantity==0">
                </td>
              </tr>
              </template>
            </tbody>
          </table>
          </div>
        </div>
        <div class="modal-footer">
          <button ref="closeModal" type="button" class="btn btn-secondary" data-dismiss="modal">{{translations('common.close')}}</button>
          <button type="button" class="btn btn-primary" @click="addShipping">{{translations('common.update')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import { mapState } from 'vuex'

export default {
  name: 'StockingModal',
  components: {
    VueElementLoading
  },
  props: {
    details: {},
    purchaseId: Number
  },
  data () {
    return {
      warehouseProducts: {},
      shippingAt: this.$invoiceTools.getCurrentDate(),
      displayWarning: false,
      isLoading: false
    }
  },
  mounted () {
    window.$('#StockingModal').on('shown.bs.modal', () => {
      this.warehouseProducts = []
      this.details.forEach(item => {
        this.warehouseProducts.push({
          detail_id: item.id,
          product_id: item.product_id,
          jan_code: item.jan_code,
          model: item.model,
          quantity: item.quantity,
          shippingAmount: item.remain_quantity > 0 ? item.remain_quantity : 0,
          arrived_quantity: item.arrived_quantity,
          remain_quantity: item.remain_quantity
        })
      })
    })
  },
  watch: {
    shippingAt: {
      handler: function (data, oldData) {
        if (Number(data.substr(8, 2)) >= 25) {
          this.displayWarning = true
        } else {
          this.displayWarning = false
        }
      }
    }
  },
  computed: {
    ...mapState(['currentLanguage'])
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    async addShipping () {
      if (this.shippingAt === '') {
        this.$toastr.warning('入荷日をご入力ください')
        return
      }

      try {
        let productList = []
        for (let i = 0; i < this.warehouseProducts.length; i++) {
          const product = this.warehouseProducts[i]
          if (Number(product.shippingAmount) === 0) {
            continue
          }

          if ((Number(product.shippingAmount) > Number(product.quantity)) ||
            (Number(product.shippingAmount) > Number(product.remain_quantity))) {
            this.$toastr.warning('入荷数をご確認ください')
            return
          }

          productList.push({
            detail_id: product.detail_id,
            product_id: product.product_id,
            quantity: Number(product.shippingAmount)
          })
        }

        if (productList.length === 0) {
          this.$toastr.warning('入荷数をご入力ください')
          return
        }

        this.isLoading = true
        const params = {
          purchase_id: this.purchaseId,
          arrived_at: this.shippingAt,
          product_list: productList
        }
        const response = await this.$http.post(this.$api_url.purchase_stocking_arrival, params)

        console.log('StockingModal:addShipping:response', response)

        if (response.data.status === true) {
          this.$toastr.success('入荷処理が更新しました。', 'Success')
          this.$parent.purchaseInfo.purchase_status = response.data.purchase_status
          this.$refs.closeModal.click()
          setTimeout(() => {
            location.reload()
          }, 500)
        } else {
          this.$toastr.error(response.data.message, 'エラー')
        }
        this.isLoading = false
      } catch (error) {
        console.log('StockingModal:addShipping:catch(error): ', error)
        this.$toastr.error('入荷処理がエラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
        this.isLoading = false
      }
    }
  }
}
</script>
